// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const SafariIcon = createSvgIcon(
  <svg fill="currentColor" viewBox="0 0 5120 5120">
    <defs>
      <linearGradient id="safari_svga" x2={0} y2="100%">
        <stop offset={0} stopColor="#19d7ff" />
        <stop offset={1} stopColor="#1e64f0" />
      </linearGradient>
    </defs>
    <circle cx={2560} cy={2560} r={2240} fill="url(#safari_svga)" />
    <path fill="red" d="M4090 1020 2370 2370l400 400z" />
    <path fill="#fff" d="m1020 4090 1350-1720 400 400z" />
    <path
      stroke="#fff"
      strokeWidth={30}
      d="M2560 540v330m0 3370v330m350-4000-57 325m-586 3318-57 327M3250 662l-113 310M1984 4138l-113 310m339-3878 57 325m586 3318 57 327M1870 662l113 310m1152 3166 113 310M1552 810l166 286m1685 2918 165 286M1265 1010l212 253m2166 2582 212 253M1015 1258l253 212m2582 2168 253 212M813 1548l286 165m2920 1685 286 165M665 1866l310 113m3166 1150 310 113M574 2202l326 58m3320 588 325 57M545 2555h330m3370 0h330M575 2905l325-57m3320-586 325-57M668 3245l310-113m3165-1152 310-113M815 3563l286-165m2920-1685 286-165M1016 3850l253-212m2580-2166 253-212M1262 4100l212-253m2166-2582 212-253M1552 4300l166-286m1685-2918 165-286M2384 548l16 180m320 3656 16 180M2038 610l47 174m950 3544 47 174M1708 730l76 163m1550 3326 77 163M1404 904l103 148m2106 3006 103 148M1135 1130l127 127m2596 2596 127 127M910 1400l148 103m3006 2107 146 100M734 1703l163 76m3326 1550 163 77M614 2033l174 47m3544 950 174 47M553 2380l180 16m3656 320 180 16m-4014 0 180-16m3656-320 180-16M614 3077l174-47m3544-950 174-47M734 3407l163-76m3326-1550 163-76M910 3710l148-103m3006-2107 146-100M1404 4206l103-148m2105-3006 104-148M1708 4380l77-163M3335 890l77-163M2038 4500l47-174m950-3544 47-174m-698 3952 16-180m320-3656 16-180"
    />
  </svg>,
  "Safari",
);
export default SafariIcon;
